export default class WebsiteInput {
    constructor($el) {
        this.$el = $el;
        this.radios = this.$el.querySelector('[data-website-radios]');
        this.radioInputs = this.radios ? Array.from(this.radios.querySelectorAll('input[type="radio"]')) : [];
        this.websiteUrl = this.$el.querySelector('[data-website-url]');

        this.radioInputs.forEach(($radio) => {
            $radio.addEventListener('change', () => this.updateVisibility());
        });

        this.updateVisibility();
    }

    updateVisibility() {
        if (!this.websiteUrl) {
            return;
        }

        const selectedRadio = this.radioInputs.find(($radio) => $radio.checked);
        const isYesSelected = selectedRadio && selectedRadio.value === '1';

        this.websiteUrl.classList.toggle('d-none', !isYesSelected);
    }
}
